import PropTypes from 'prop-types';
import React from 'react';
import { InstallmentsStyles } from './InstallmentsWithoutInterest.style';

const InstallmentsWithoutInterest = ({ product }) => {
  const { installmentsWithoutInterest = [] } = product;
  if (!installmentsWithoutInterest.length) {
    return null;
  }
  const uniqueInstallments = [...new Set(installmentsWithoutInterest.map((item) => Number(item.installments)))];

  const maxInstallments = uniqueInstallments.length > 0 ? Math.max(...uniqueInstallments) : 0;

  return maxInstallments > 0 ? (
    <>
      <div className="installments-text">
        <span>{maxInstallments} cuotas sin interés</span>
        <span className="cmr-icon" />
      </div>
      <style jsx>{InstallmentsStyles}</style>
    </>
  ) : null;
};

InstallmentsWithoutInterest.defaultProps = {
  product: {},
};

InstallmentsWithoutInterest.propTypes = {
  product: PropTypes.object,
};

export default InstallmentsWithoutInterest;
